<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="抄表计划" name="MeterBudget">
        <MeterNoteList v-if="card_index==='MeterBudget'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import MeterNoteList from "./MeterBudget.vue";

export default {
  components: {MeterNoteList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return {
      card_index : 'MeterBudget'
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_plan/MeterPlanMain.vue